import { useI18nStore } from '../../shared/i18n/i18nStore';
import './depositProof.css';

/** Pre-transfer reminder at the end of the ARS deposit sheet (PM, 2026-09-15). */
export function DepositImportantNotice({ onSupport }: { onSupport?: () => void }) {
  const t = useI18nStore((s) => s.t);
  return (
    <section className="deposit-important-notice" aria-label={t('depositNoticeTitle')}>
      <strong>{t('depositNoticeTitle')}</strong>
      <p>{t('depositNoticeBody')}</p>
      {onSupport ? <button type="button" className="deposit-important-notice-support" onClick={onSupport}>{t('depositNoticeSupport')}</button> : null}
    </section>
  );
}
